(() => {
  if (window.FreewinkReviewSummary) return;

  const selector = '[data-freewink-review-summary]';

  const update = (node, summary) => {
    if (!node || !summary || node.dataset.productId !== summary.productId) return;
    const total = Math.max(0, Number(summary.total) || 0);
    const average = Math.max(0, Math.min(5, Number(summary.average) || 0));
    node.hidden = total < 1;
    if (!total) return;

    node.style.setProperty('--fw-review-summary-fill', `${(average / 5) * 100}%`);
    node.dataset.reviewTarget = summary.targetId || '';

    const averageNode = node.querySelector('[data-freewink-review-summary-average]');
    const countNode = node.querySelector('[data-freewink-review-summary-count]');
    const singular = node.dataset.reviewSingular || 'customer review';
    const plural = node.dataset.reviewPlural || 'customer reviews';
    const outOfFive = node.dataset.outOfFive || 'out of 5';
    const label = total === 1 ? singular : plural;

    if (averageNode) {
      averageNode.hidden = node.dataset.showAverage !== 'true';
      averageNode.textContent = node.dataset.showAverage === 'true' ? average.toFixed(1) : '';
    }
    if (countNode) {
      countNode.hidden = node.dataset.showCount !== 'true';
      countNode.textContent = node.dataset.showCount === 'true' ? `${node.dataset.showAverage === 'true' ? ' · ' : ''}${total} ${label}` : '';
    }

    const button = node.querySelector('[data-freewink-review-summary-link]');
    if (button) button.setAttribute('aria-label', `${average.toFixed(1)} ${outOfFive}, ${total} ${label}`);
  };

  const findExistingSummary = (node) => {
    const reviewRoot = [...document.querySelectorAll('[data-freewink-reviews]')].find(
      (item) => item.dataset.productId === node.dataset.productId,
    );
    if (!reviewRoot || !reviewRoot.dataset.reviewTotal) return;
    update(node, {
      productId: reviewRoot.dataset.productId,
      total: reviewRoot.dataset.reviewTotal,
      average: reviewRoot.dataset.reviewAverage,
      targetId: reviewRoot.id,
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll(selector).forEach((node) => {
      if (node.dataset.reviewSummaryInitialized !== 'true') {
        node.dataset.reviewSummaryInitialized = 'true';
        node.querySelector('[data-freewink-review-summary-link]')?.addEventListener('click', () => {
          const target = node.dataset.reviewTarget ? document.getElementById(node.dataset.reviewTarget) : document.querySelector('[data-freewink-reviews]');
          target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      findExistingSummary(node);
    });
  };

  document.addEventListener('freewink:reviews:summary', (event) => {
    document.querySelectorAll(selector).forEach((node) => update(node, event.detail));
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  window.FreewinkReviewSummary = { init };
})();
